/**
 * Shared inline styles for paginated list pages.
 * Extracts the common filter bar, table, pagination, and badge styles
 * to keep page files under 300 lines.
 */

export const listStyles: Record<string, React.CSSProperties> = {
  filterBar: { display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" },
  searchInput: {
    flex: 1,
    minWidth: 200,
    padding: "8px 12px",
    fontSize: 13,
    border: "1px solid var(--color-border)",
    borderRadius: 6,
  },
  select: {
    padding: "8px 12px",
    fontSize: 13,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg)",
  },
  searchBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
  loading: { fontSize: 14, color: "var(--color-text-secondary)", padding: 24 },
  error: { fontSize: 14, color: "var(--color-danger)", padding: "8px 0" },
  empty: {
    fontSize: 14,
    color: "var(--color-text-secondary)",
    padding: 24,
    textAlign: "center",
  },
  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    textAlign: "left",
    padding: "10px 12px",
    fontSize: 12,
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    borderBottom: "1px solid var(--color-border)",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "10px 12px",
    fontSize: 13,
    borderBottom: "1px solid var(--color-border)",
    whiteSpace: "nowrap",
  },
  tdMono: {
    padding: "10px 12px",
    fontSize: 12,
    borderBottom: "1px solid var(--color-border)",
    whiteSpace: "nowrap",
    fontFamily: "var(--font-mono)",
  },
  clickRow: { cursor: "pointer" },
  badge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
  },
  pagination: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 0",
  },
  pageInfo: { fontSize: 13, color: "var(--color-text-secondary)" },
  pageButtons: { display: "flex", gap: 8 },
  pageBtn: {
    padding: "6px 14px",
    fontSize: 13,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg)",
  },
};
